import { Box, Flex, FlexProps, Heading, Icon, Text } from "@chakra-ui/react";
import { ReactNode, useMemo } from "react";
import { BsCheckCircleFill, BsFillExclamationCircleFill } from "react-icons/bs";
import {
  HiDotsCircleHorizontal,
  HiOutlineDotsCircleHorizontal,
} from "react-icons/hi";
import { IoTimeSharp } from "react-icons/io5";

export interface PaymentStatusCardProps {
  status: "success" | "failed" | "pending" | "expired";
  messages?: {
    failed: string;
    success: string;
    pending: string;
    expired: string;
  };
  actionButton: ReactNode;
  paymentStatusBannerProps?: FlexProps;
  gratitudeMessageProps?: FlexProps;
}

export function PaymentStatusCard({
  status,
  messages,
  actionButton,
  paymentStatusBannerProps,
  gratitudeMessageProps,
  ...props
}: PaymentStatusCardProps & FlexProps) {
  const { primaryColor, icon } = useMemo(
    () => ({
      primaryColor:
        status === "success"
          ? "success.500"
          : status === "failed"
            ? "damger.500"
            : status === "pending"
              ? "warning.500"
              : status === "expired"
                ? "surface.500"
                : "surface.500",
      icon:
        status === "success"
          ? BsCheckCircleFill
          : status === "failed"
            ? BsFillExclamationCircleFill
            : status === "pending"
              ? HiDotsCircleHorizontal
              : status === "expired"
                ? IoTimeSharp
                : HiOutlineDotsCircleHorizontal,
    }),
    [status],
  );

  return (
    <Flex
      p="1.5rem"
      pb="2rem"
      shadow="md"
      maxW="container.md"
      mx="auto"
      direction="column"
      {...props}
    >
      <Flex
        alignItems="center"
        gap="0.75rem"
        fontSize="1.5rem"
        p="1rem"
        color="white"
        backgroundColor={primaryColor}
        borderRadius="0.2rem"
        {...paymentStatusBannerProps}
      >
        <Icon as={icon} />
        <Heading as="h3" textTransform="capitalize" fontSize="inherit">
          Payment {status === "success" ? "Successful" : status}
        </Heading>
      </Flex>
      <Box
        fontWeight={600}
        pt="1.5rem"
        fontSize="1rem"
        lineHeight="1.75rem"
        {...gratitudeMessageProps}
      >
        <Text>Thank you,</Text>
        <Text>
          <>{messages && messages[status]}</>
        </Text>
      </Box>
      <>{actionButton}</>
    </Flex>
  );
}
